import { render, staticRenderFns } from "./Catch.vue?vue&type=template&id=4c36d3a4"
import script from "./Catch.vue?vue&type=script&lang=js"
export * from "./Catch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports